import UserAuthKey from '../../../../components/Common/UserAuthKey';
import axios from 'axios';
const apiUrl = process.env.REACT_APP_OMS_API; // Create store order return (API: create-store-return-order)

export const fetchStoreOrderList = async ({ params }) => {
  try {
    const bearerToken = UserAuthKey();
    const config = {
      method: 'POST',
      url: `${apiUrl}v1/orders/get-store-orders`,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Content-Type': 'application/json',
      },
      data: {
        ...params,
      },
    };
    const response = await axios(config);
    //  dispatch(setStoreOrderList(response?.data));
    return response?.data;
  } catch (error) {
    throw error;
  }
};
